import { createContext, useContext } from 'react';

export const DataContext = createContext({
  isTemplate: true,
});

const value = { isTemplate: false };

// Use to override default isTemplate to false
export const FarmDataContextProvider = ({ children }) => {
  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useDataContext = () => useContext(DataContext);
